(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity-change]');
    if (!button) return;
    const control = button.closest('[data-cart-quantity-control]');
    const form = button.closest('[data-cart-form]');
    const input = control?.querySelector('[data-cart-quantity]');
    const updateButton = form?.querySelector('[data-cart-update]');
    if (!form || !input || !updateButton) return;
    const current = Number.parseInt(input.value, 10) || 0;
    const change = Number.parseInt(button.dataset.cartQuantityChange, 10) || 0;
    const next = Math.max(0, current + change);
    if (next === current) return;
    input.value = String(next);
    const status = form.querySelector('[data-cart-status]');
    if (status) status.textContent = next === 0 ? form.dataset.cartRemoving : form.dataset.cartUpdating;
    form.querySelectorAll('[data-cart-quantity-change]').forEach((item) => { item.disabled = true; });
    form.requestSubmit(updateButton);
  });

  } catch(e) { console.error(e); }
})();
})();
